export default {
  posts: `My posts`,
  contact: `Contact us`,
  about: `About`
}



// WEBPACK FOOTER //
// ./src/lang/en/categories.js